import { type ErrorComponentProps, Link } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useToast } from '@/hooks/use-toast';
import { CONTACT_EMAIL } from '@/lib/constants';
import { sendErrorToSentry } from '@/lib/utils';

import { Button } from '../ui/button';

export const GlobalError = ({ error }: ErrorComponentProps): JSX.Element => {
  const [seeTrace, setSeeTrace] = useState(false);
  const { toast } = useToast();

  useEffect(() => {
    if (import.meta.env.PROD) {
      sendErrorToSentry(error);
    }
  }, [error]);

  return (
    <div className="flex flex-col justify-center items-center h-full w-full">
      <h1 className="text-2xl">
        <FormattedMessage id="global.error.title" />
      </h1>
      <Link to="/" className="mt-8">
        <Button variant="main">
          <FormattedMessage id="global.error.goBack" />
        </Button>
      </Link>
      <p className="text-sm text-gray-500 mt-4">
        <FormattedMessage id="global.error.stuck" />
        <Link
          className="text-primary-500"
          onClick={() => {
            navigator.clipboard.writeText(CONTACT_EMAIL);
            toast({ title: 'global.copiedToClipboard' });
          }}
        >
          {CONTACT_EMAIL}
        </Link>
      </p>
      <Button
        className="text-sm text-gray-500 underline"
        onClick={() => setSeeTrace(t => !t)}
      >
        <FormattedMessage id="global.error.toggleTrace" />
      </Button>
      {seeTrace && (
        <div className="border m-4 p-4">
          <h3>
            <b>
              <FormattedMessage id="global.error.message" />
            </b>{' '}
            {error.message}
          </h3>
          <p>
            <b>
              <FormattedMessage id="global.error.stack" />
            </b>{' '}
            {error.stack}
          </p>
        </div>
      )}
    </div>
  );
};
